import React from 'react';

import { Box, Button, Heading, Text, TextInput, ButtonPrimary } from '@primer/components'
import { Link } from "react-router-dom";
import { useProduct } from '../../hooks/useProduct'
import useAnalytics from '../../hooks/useAnalytics'

const NO_CHARGE = 'NO_CHARGE'
const pricings = [
  {
    title: "Individual",
    isPrimary: false,
    duration: 'forever',
    price: "Free",
    checkoutPriceId: NO_CHARGE,
    features: {
      publicRepositories: "Unlimited",
      privateRepositories: "No",
      support: "No",
    }
  },
  {
    title: "Team",
    isPrimary: true,
    duration: 'per month',
    price: "$49",
    isRibbon: true,
    checkoutPriceId: process.env.REACT_APP_PRICE_ID_TEAM,
    features: {
      publicRepositories: "Unlimited",
      privateRepositories: 10,
      support: "24/7 email and chat",
    }
  },
  { 
    title: "Unlimited",
    isPrimary: false,
    duration: 'per month',
    price: "$99",
    checkoutPriceId: process.env.REACT_APP_PRICE_ID_UNLIMITED,
    features: {
      publicRepositories: "Unlimited",
      privateRepositories: "Unlimited",
      support: "24/7 email and chat",
    }
  },
]

function PricingBox(props) {
  const JoinButton = props.pricing.isPrimary ? ButtonPrimary : Button 
  const analytics = useAnalytics()
  const [showWorkspaceId, setShowWorkspaceId] = React.useState(false)
  let child
  const productDetails = useProduct()

  if (props.pricing.checkoutPriceId === NO_CHARGE) {
    child = (
      <JoinButton
        as="a"
        href={productDetails.bitbucketMarketplaceLink}
        onClick={() => analytics.track('5XBG8FTS')}
      >
        Choose
      </JoinButton>
    )
  } else {
    // change to onClick show input asking for workspaceID
    if (showWorkspaceId) {
      child = (
        <form className="pt-6" style={{borderTop: '1px solid #dedede'}} action={process.env.REACT_APP_CHECKOUT_URL} method="POST" encType='application/x-www-form-urlencoded'>
          <Text as="p" fontWeight="bold">Finally, what Bitbucket workspace is the licence for?
            <details className="d-inline ml-1 text-normal">
              <summary className="d-inline ">Need help finding it?</summary>
              <span className="ml-1">Check your Bitbucket url. For bitbucket.org/<b>code-review-doctor</b>/example it's <b>code-review-doctor</b></span>
            </details>
          </Text>
          <input type="hidden" value={props.pricing.checkoutPriceId} name="price_id" />
          <TextInput className="mt-2 mb-6" name="organisation_name" autoFocus required />
          <input type="hidden" value={window.location.origin} name="domain" />
          <JoinButton onClick={() => analytics.track('5XBG8FTS')}>
            🛡️ Buy securely via Stripe
          </JoinButton>
         </form>
      )

    } else {
      child =(
        <JoinButton
          as="a"
          onClick={() => setShowWorkspaceId(true)}
        >
          Choose
        </JoinButton>
      )

    }
  }

  return (
    <Box
      marginRight="15px"
      marginLeft="15px"
      paddingLeft="20px"
      paddingRight="20px"
      className="text-center pricing-box bg-white price-active col-md-4 mb-md-0 mb-4 pb-6"
    >
      {props.pricing.isRibbon && <div className="ribbon-box"><Text>Popular</Text></div> }
      <Heading as="h4" fontSize="1" className="text-uppercase">{props.pricing.title}</Heading>
      <Heading as="h1">{ props.pricing.price }</Heading>
      <Text className="text-uppercase">{ props.pricing.duration }</Text>
      <Box className="mt-6 mb-6">
        <p>Fixes suggested in PRs: <b>yes</b></p>
        <p>Full code scan any time: <b>yes</b></p>
        <p>Public repositories: <b>{props.pricing.features.publicRepositories}</b></p>
        <p>Private repositories: <b>{props.pricing.features.privateRepositories}</b></p>
        <p>Support: <b>{props.pricing.features.support}</b></p>
      </Box>
      { child }
    </Box>
  );
}


export default function Component(props) {
  const productDetails = useProduct()
  return (
    <Box className="container-lg pb-4 pt-8">
      <Heading
        as="h2"
        marginBottom="40px"
        textAlign="center"
        className="text-white"
      >Setup Bitbucket integration</Heading>
      <Text className="text-white ml-3 f3 text-center" as="p">Merge fewer bugs: Python and Django fixes suggested right in your Bitbucket pull requests.</Text>
      <Box marginTop="50px" className="d-md-flex">
        <PricingBox pricing={pricings[0]} />
        <PricingBox pricing={pricings[1]} />
        <PricingBox pricing={pricings[2]} />
      </Box>
      <Text as="p" className="text-white f3 text-center mt-6 mb-0 pb-0">Or read about our <Link to="/features/python" className="text-white text-underline">Python</Link>, <Link to="/features/django" className="text-white text-underline">Django</Link>, or <a className="text-white text-underline" href={productDetails.gitHubMarketplaceLink}>GitHub</a> code review capabilities.</Text>
    </Box>
  )
}


Component.defaultProps = {
  title: "Our Price"
}